import { conditions_of_employment_and_assurances_text_V3 } from "../../shared/conditions_of_employment_and_assurances_text";

export default {
  name: "Conditions of Employment and Assurances for H-2A Agricultural Clearance Orders",
  pageInfo: {
    text: conditions_of_employment_and_assurances_text_V3,
  },
  sections: [
    {
      name: "Signer Information",
      fields: [
        {
          code: "G.1",
          machine_name: "eta_790a_i1_last",
          widget: "text",
          label: "Last (family) Name",
          validate: [
            "required",
            { minLength: 2, message: "Enter a full last name." },
          ],
          parse: ["noNumbers"],
          maxLength: 35,
          tooltip:
            "Enter the last (family) name(s) of the person with authority to sign on behalf of the employer.",
        },
        {
          code: "G.2",
          machine_name: "eta_790a_i2_first",
          widget: "text",
          label: "First (given) Name",
          parse: ["noNumbers"],
          validate: [
            "required",
            { minLength: 2, message: "Enter a full first name." },
          ],
          maxLength: 35,
          tooltip:
            "Enter the first (given) name of the person with authority to sign on behalf of the employer.",
        },
        {
          code: "G.3",
          machine_name: "eta_790a_i3_middle",
          widget: "text",
          label: "Middle Initial",
          parse: ["noNumbers"],
          maxLength: 3,
          tooltip:
            "Enter the middle name of the person with authority to sign on behalf of the employer, if applicable.",
        },
        {
          code: "G.4",
          machine_name: "eta_790a_i4_title",
          widget: "text",
          label: "Title",
          validate: [
            "required",
            { minLength: 5, message: "Enter a full title." },
          ],
          maxLength: 60,
          tooltip:
            "Enter the job title of the person with authority to sign on behalf of the employer.",
        },
      ],
    },
    {
      name: "Signature",
      fields: [
        {
          name: "Signature",
          code: "G.5",
          widget: "file_upload",
          uploadTitle: "Signature Upload",
          accept_multiple: false,
          accept_multiple_warning_message: `The upload in this section is limited to the signature of the person authorized to file on behalf of the employer. Additional document uploads are not permitted with the Agricultural Clearance Order, but may be uploaded with the Form ETA-9142A.`,
          machine_name: "eta_790a_i5_signature",
          update_time: "eta_790a_i6_date_signed",
          dontShowAsterisk: true,
          label:
            "<b>By signing this document with an electronic signature</b>, I acknowledge the Conditions of Employment and Assurances stated above.",
          fileTypes: [".png", ".jpeg", ".jpg", ".svg"],
          validate: ["required", "checkValue"],
          tooltip:
            "The person with authority to sign on behalf of the employer must sign and date the agricultural clearance order. An electronic ordigital signature is acceptable. Read the entire application and verify all contained information prior to signing. Use a month/day/full year (mm/dd/yyyy) format.",
        },
      ],
    },
    {
      divider: "hide",
      fields: [
        {
          reviewHidden: true,
          code: "G.5",
          machine_name: "files",
          widget: "text",
          hidden: true,
        },
      ],
    },
  ],
};
